module.exports = __webpack_public_path__ + "static/media/tya201.2eb38ac0.pdf";